import React from "react";

import { ServiceContextProvider } from "../_context/service.context";
import { SettingContextProvider } from "../_context/setting.contax";
import { WalletProvider } from "../_context/wallet.context";

const AppRuntimeProviders = ({ children }) => (
  <ServiceContextProvider>
    <WalletProvider>
      <SettingContextProvider>{children}</SettingContextProvider>
    </WalletProvider>
  </ServiceContextProvider>
);

export default AppRuntimeProviders;
